import type { FaireProductEntity } from "../../entity_types/product";

export const p_cr3ew3k2zb: FaireProductEntity = {
  token: "p_cr3ew3k2zb",
  type: "product",
  name: "From Scratch Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/ae3e2673cceb9dfde270cb1697c15f1a70e01748b6867de19d46dc63d678e3f4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b045e54254b9f42bc66b11a88d3f0a09504456a253a60e3617f08393f6fd1281.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:36.859Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
